









































































import Vue from 'vue';
import Component from 'vue-class-component';
import axiosInstance from "../../axios";
//@ts-ignore
import store from "../../store";
import {CreateReportResponse, FormField, SelectOption} from "../../../types";

@Component({
    components: {

    },
    props: {
        createReportUrl: {
            required: true,
            type: String,
        },
        gameId: {
            required: true,
            type: String,
        },
        playerId: {
            required: true,
            type: String,
        },
    }
})

export default class BugReportForm extends Vue {
    private success: boolean = false;
    private createReportUrl!: string;
    private gameId!: string;
    private playerId!: string;

    private formFields: Array<string> = [
        'description',
        'name',
        'email',
        'type'
    ];

    private description: FormField = {
        id: 'description',
        name: 'description',
        type: '',
        label: '',
        value: '',
        success: true,
        error: null,
        // @ts-ignore
        placeholder: this.$t('message.describe_problem') + ' *',
    };

    private name: FormField = {
        id: 'name',
        name: 'name',
        type: 'text',
        label: '',
        value: '',
        success: true,
        error: null,
        //@ts-ignore
        placeholder: this.$t('message.fill_name'),
    };

    private email: FormField = {
        id: 'email',
        name: 'email',
        type: 'text',
        label: '',
        value: '',
        success: true,
        error: null,
        //@ts-ignore
        placeholder: this.$t('message.email'),
    };

    private type: FormField = {
        id: 'type',
        name: 'type',
        type: '',
        label: '',
        value: '',
        success: true,
        error: null,
        // @ts-ignore
        placeholder: this.$t('message.type_problem') + ' *',
    };

    private options: Array<SelectOption> = [
        {
            value: 1,
            // @ts-ignore
            label: this.$t('message.connection_problem')
        },
        {
            value: 2,
            // @ts-ignore
            label: this.$t('message.camera_issues')
        },
        {
            value: 3,
            // @ts-ignore
            label: this.$t('message.sound_issues')
        },
        {
            value: 4,
            // @ts-ignore
            label: this.$t('message.game_problems')
        },
        {
            value: 5,
            // @ts-ignore
            label: this.$t('message.other_problems')
        }
    ];

    /**
     * Ширина окна
     */
    private get windowWidth(): number
    {
        return window.innerWidth;
    }

    /**
     * Высота окна
     */
    private get windowHeight(): number
    {
        return window.innerHeight;
    }

    /**
     * Закрыть форму
     */
    private close(): void
    {
        this.$emit('close');
    }

    /**
     * Состояние игры
     * @private
     */
    private get activityId(): string
    {
        if (!store.getters.getGameState.tasks.state.activity_id) {
            return '';
        }

        return store.getters.getGameState.tasks.state.activity_id.toString();
    }

    /**
     * Создать заявку
     * @private
     */
    private createReport()
    {
        const params = new URLSearchParams();
        params.append('email', this.email.value.toString());
        params.append('game_id', this.gameId);
        params.append('name', this.name.value.toString());
        params.append('player_id', this.playerId);
        params.append('type', ((this.type.value as SelectOption).value || '').toString());
        params.append('window_height', this.windowHeight.toString());
        params.append('window_width', this.windowWidth.toString());
        params.append('activity_id', this.activityId);
        params.append('description', this.description.value.toString());
        params.append('devices', JSON.stringify(this.devices));
        params.append('date', (new Date()).toString());
        params.append('voximplant_logs', JSON.stringify(this.$conferenceManager.videoManager.getLogs()));
        params.append('game_logs', JSON.stringify(this.$logService.gameLogs));

        this.createReportRequest(params).then(response => {
            if (response.success) {
                this.success = true;
            }
        }).catch(error => {
            this.clearValidationErrors();
            this.showValidationErrors(error.errors);
        });
    }

    /**
     * Очищает ошибки валидации
     */
    private clearValidationErrors(): void
    {
        this.formFields.forEach((fieldProperty) => {
            const field: FormField = (this as any)[fieldProperty];
            field.error = null;
        });
    }

    /**
     * Показать ошибки валидации
     */
    private showValidationErrors(errors: any)
    {
        this.formFields.forEach((fieldProperty) => {
            const field: FormField = (this as any)[fieldProperty];
            field.success = true;

            for (let attribute in errors) {
                if (errors[attribute].length > 0 && typeof errors[attribute][0] !== 'undefined') {
                    const errorMessage = errors[attribute][0];
                    if (field.name === attribute) {
                        field.error = errorMessage;
                        field.success = false;
                    }
                }
            }
        });
    }

    /**
     * Запрос на создание заявки
     * @param request
     * @private
     */
    private createReportRequest(request: any): Promise<CreateReportResponse>
    {
        return new Promise((resolve, reject) => {
            axiosInstance.post(this.createReportUrl, request).then( response => {
                if (typeof response.data.errors === 'undefined') {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Список устройств
     * @private
     */
    private get devices(): Array<{[key:string]: string|number}>
    {
        let devices: Array<{[key:string]: string|number}> = [];

        this.$conferenceManager.devicesManager.getCamerasList().forEach((device) => {
            if (typeof device !== 'undefined') {
                let deviceData: any = device;
                deviceData.type = 'camera';
                devices.push(deviceData);
            }
        });

        this.$conferenceManager.devicesManager.getMicrophonesList().forEach((device) => {
            if (typeof device !== 'undefined') {
                let deviceData: any = device;
                deviceData.type = 'microphone';
                devices.push(deviceData);
            }
        });

        return devices;
    }
}
